import React, { useEffect, useState } from "react";

import { ESTATE_SETUP_URL, ESTATE_UPLOAD_RESULT_URL } from "configs/constants";

import Form from "components/Form";
import Table from "@Components/Table";
import * as Yup from "yup";
import eightAxios from "configs/axiosConfig";
import LoadingIcon from "@Components/LoadingIcon/LoadingIcon";
import { Paper } from "@material-ui/core";
import Alert from "@material-ui/lab/Alert";
import axios from "axios";
import { useTranslation } from "react-i18next";

let model = [
  { id: "SN", label: "SN", type: "string" },
  { id: "zone_code", label: "Zone Code", type: "string" },
  { id: "zone_name", label: "Zone Name", type: "string" },
  { id: "state", label: "State Name", type: "string" },
  { id: "region_code", label: "Region Code", type: "string" },
  { id: "region_name", label: "Region Name", type: "string" },
  { id: "estate_code", label: "Estate Code", type: "string" },
  { id: "estate_name", label: "Estate Name", type: "string" },
  { id: "division_code", label: "Division Code", type: "string" },
  { id: "division_name", label: "Division Name", type: "string" },
  { id: "block_code", label: "Block Code", type: "string" },
  { id: "block_name", label: "Block Name", type: "string" },
  { id: "perimeter_hectarage", label: "Perimeter Hectarage", type: "float" },
  { id: "planted_hectarage", label: "Planted Hectarage", type: "float" },
  { id: "harvested_hectarage", label: "Harvested Hectarage", type: "float" },
  { id: "status", label: "Status", type: "string" },
  { id: "remarks", label: "Remarks", type: "string" },
];

const FileDownload = require("js-file-download");

const SUPPORTING_DOCUMENT_FORMATS = [
  ".csv",
  "text/csv",
  "application/vnd.ms-excel",
];

const initialValues = {};

const detailURL = "/configuration/get-config/";
const templateURL = "download-template/?type=estate";

const EstateSetup = () => {
  const { t } = useTranslation();

  const [displayTable, setDisplayTable] = useState(false);
  const [tableData, setTableData] = useState(null);
  const [buttonCounter, setButtonCounter] = useState(0);
  const [fileSize, setFileSize] = useState(null);
  const [loading, setLoading] = useState(false);

  const validationSchema = Yup.object({
    file: Yup.mixed()
      .test("fileSize", "File is too large", (value) => {
        if (value === null) {
          return false;
        } else if (typeof value === "string") {
          return true;
        } else {
          return value.size <= fileSize;
        }
      })
      .test("fileType", "Unsupported file type", (value) => {
        if (value === null) {
          return false;
        } else if (typeof value === "string") {
          return true;
        } else {
          console.log(value.type);
          return SUPPORTING_DOCUMENT_FORMATS.includes(value.type);
        }
      }),
  });

  const fetchDetails = () => {
    setLoading(true);
    eightAxios
      .get(detailURL)
      .then((response) => {
        if (response.status === 200) {
          if (response.data.max_file_upload_size) {
            setFileSize(response.data.max_file_upload_size * 1024 * 1024);
          }
        }
        setLoading(false);
      })
      .catch((error) => {
        if (error.response) {
          console.log(error.response);
        }
        setLoading(false);
      });
  };

  const fetchTemplate = () => {
    setLoading(true);
    const API_VERSION = "v1";
    const API_URL = process.env.REACT_APP_API_URL;
    let baseURL = `${API_URL}${API_VERSION}/`;
    const headers = {
      Authorization: `JWT ${localStorage.getItem("token")}`,
    };
    axios({
      url: baseURL + templateURL,
      method: "get",
      headers: headers,
      responseType: "blob",
    })
      .then(function (response) {
        FileDownload(response.data, "Estate_upload_template.csv");
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    fetchDetails();
  }, []);

  const formFields = [
    {
      type: "fileupload",
      name: "file",
      accept: ".csv",
      label: "Estate Upload File",
      buttonText: "Browse",
      supportedTypes: [t("csv file only")],
    },
  ];

  const formButtons = [
    {
      type: "submit",
      label: "Submit",
      color: "primary",
    },
  ];

  if (loading) {
    return <LoadingIcon image text="Loading" />;
  }

  return (
    <div>
      <Paper style={{ padding: "10px" }}>
        <Form
          initialValues={initialValues}
          submitUrl={ESTATE_SETUP_URL}
          formFields={formFields}
          formButtons={formButtons}
          afterSubmit={() => {
            setDisplayTable(true);
            setButtonCounter(buttonCounter + 1);
          }}
          isMultipart
          formTitle="Estate Setup"
          validationSchema={validationSchema}
          noTypography={true}
          downloadTemplate={fetchTemplate}
        />
        {tableData && tableData.extra ? (
          <Alert
            severity={tableData.extra.failed > 0 ? "error" : "success"}
            style={{ marginTop: "10px", marginBottom: "10px" }}
          >
            {`Total: ${
              tableData.extra.success + tableData.extra.failed
            }, Successful: ${tableData.extra.success}, Failed: ${
              tableData.extra.failed
            }`}
          </Alert>
        ) : null}
      </Paper>
      {displayTable ? (
        <Table
          model={model}
          noFilter
          proxyURL={ESTATE_UPLOAD_RESULT_URL}
          outerFetchTrigger={buttonCounter}
          noAddButton
          excelExport={{ fileName: "EstateSetupResult" }}
          polling
          setTableData={setTableData}
        />
      ) : null}
    </div>
  );
};

export default EstateSetup;
